import { useState } from "react";
import { Search } from "lucide-react";
import { api, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const KuberInvoiceLookup = ({ row, busy, onMatch }) => {
  const [q, setQ] = useState("");
  const [hit, setHit] = useState(null);
  const [err, setErr] = useState("");
  const [looking, setLooking] = useState(false);

  const lookup = async (e) => {
    e?.preventDefault();
    if (!q.trim()) return;
    setLooking(true);
    setErr("");
    setHit(null);
    try {
      const { data } = await api.get("/kuber/payments/lookup", {
        params: {
          doc_number: q.trim(),
          amount: row.amount || 0,
          fee: row.fee || 0,
          method: row.method || "",
        },
      });
      setHit(data);
    } catch (e2) {
      setErr(String(e2.response?.data?.detail || "Could not find that invoice"));
    } finally {
      setLooking(false);
    }
  };

  return (
    <div className="mt-3 border-t border-dashed border-border pt-3" data-testid={`kuber-lookup-${row.id}`}>
      <p className="text-[11px] uppercase tracking-wider text-muted-foreground">
        Match to any invoice by number
      </p>
      <form onSubmit={lookup} className="mt-2 flex gap-2">
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Invoice number, e.g. 211275"
          className="h-9 max-w-xs rounded-none"
          inputMode="numeric"
          data-testid={`kuber-lookup-input-${row.id}`}
        />
        <Button type="submit" variant="outline" className="h-9 rounded-none" disabled={looking}
          data-testid={`kuber-lookup-btn-${row.id}`}>
          <Search className="mr-1.5 h-3.5 w-3.5" /> Find
        </Button>
      </form>
      {err && <p className="mt-2 text-sm text-[#9A3412]" data-testid={`kuber-lookup-error-${row.id}`}>{err}</p>}
      {hit && (
        <div className="mt-2 flex flex-wrap items-center justify-between gap-3 border border-border bg-[#FBF8F2] px-3 py-2"
          data-testid={`kuber-lookup-hit-${row.id}`}>
          <span className="text-sm">
            <span className="tabular font-semibold">#{hit.doc_number}</span> · {hit.customer_name || "No name"} ·{" "}
            {hit.branch} · {hit.date} · <span className="tabular">{money(hit.total)}</span> · paid by {hit.paid_by}
            <span className="mt-1 block text-xs text-muted-foreground">{hit.why}</span>
          </span>
          {hit.action !== "none" && (
            <Button
              className="h-9 rounded-none bg-[#C5A059] font-semibold text-[#0A0A0A] hover:bg-[#B38F4E]"
              disabled={busy}
              onClick={() => onMatch(row.id, hit.id)}
              data-testid={`kuber-lookup-match-${row.id}`}
            >
              {hit.action === "relabel" ? "Match — relabel as Kuber" : "Apply to this invoice"}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
